import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import * as fileSaver from 'file-saver';
import { appConstants } from '../helpers/constants';
import { StandardApiRequest, Carrier, Account, UserInfo, SurchargeTotal } from '../helpers/interfaces';
import { ApiService } from '../services/api.service.service';
import { SessionService } from '../services/session.service';
import { UserService } from '../services/user.service';

@Component({
  selector: 'app-surcharge-month-chart',
  templateUrl: './surcharge-month-chart.component.html',
  styleUrls: ['./surcharge-month-chart.component.css']
})
export class SurchargeMonthChartComponent implements OnInit {

  constructor(private apiService: ApiService,  private notification: MatSnackBar, private router: Router, private sessionService: SessionService, private userService: UserService) { }

  displayedColumns: string[] = ['month', 'year', 'net-charge'];
  dataTable: MatTableDataSource<SurchargeTotal> = new MatTableDataSource();
  
  defaultScale = appConstants.fun.getChartScale('Month', 'Amount in Dollars');
  costPerPoundScale = appConstants.fun.getChartScale('Month', 'Amount in Dollars/lb.')
  totalWeightScale = appConstants.fun.getChartScale('Month', 'Weight in Pounds')

  userInfo!: UserInfo;
  dateToday: Date = new Date();
  form: StandardApiRequest = {
    StartDate: new Date(this.dateToday.getFullYear(), 1, 1),
    EndDate: new Date(this.dateToday),
    CarrierId: 0,
    AccountId: 0,
    ClientId: 0,
    IsPageLoad: false
  }

  Carriers: Carrier[] = [{ CarrierId: 0, CarrierName: "All" }]
  Accounts: Account[] = [{ AccountId: 0, AccountNumber: "All" }]
  netChargeLoading: boolean = true;
  weightLoading: boolean = true;
  freightLoading: boolean = true;
  surchargeLoading: boolean = true;
  costPackageLoading: boolean = true;
  costPoundLoading: boolean = true;

  
  // [SURCHARGE TOTAL MONTH]
  surchargeTotalChartData: Array<any> = [{ data: [] }];
  surchargeTotalChartLabels: Array<any> = [];
  surchargeTotalChartOptions: any = {
    responsive: true,
    scales: this.defaultScale,
    isLoading: true,
    tooltips: {
      enabled: true,
      mode: 'single',
      callbacks: {
        label: function (tooltipItems: { yLabel: string; }, data: any) {
          return ' $' + tooltipItems.yLabel;
        }
      }
    }
  };
  surchargeTotalChartLegend: boolean = false;
  surchargeTotalChartType: any = appConstants.CHARTS.TYPES.LINE_CHART;
  //surchargeTotalChartColors: Array<any> = [appConstants.OPTIONS.CHARTS.DEFAULT.LINE_CHART_DEFAULT_COLOR];
  public surchargeTotalChartColors: Array<any> = [{}];
  
  ngOnInit(): void {
    this.userInfo = this.userService.userInfo;
    this.sessionService.trendsForm.ClientId = this.userInfo.ClientId;
    this.form = this.sessionService.trendsForm;

    this.apiService.makeStandardApiCall('user/GetCarriersByClient', this.form).subscribe(
      (data: any) => {
        if (data.StatusCode != 401) {
          const carriers: Carrier[] = JSON.parse(data.Value);
          this.Carriers = [];
          this.Carriers.push({ CarrierName: 'All', CarrierId: 0 });
          carriers.forEach(element => {
            this.Carriers.push(element);
          });
        }
      }
    );
    this.updateDashboardComponents();
    this.updateAccountsList();
  }

  updateAccountsList(): void {
    this.apiService.makeStandardApiCall('user/GetAccountsByClientCarrier', this.form).subscribe(
      (data: any) => {
        if (data.StatusCode != 401) {
          const accounts: Account[] = JSON.parse(data.Value);
          this.Accounts = [];
          this.Accounts.push({ AccountNumber: 'All', AccountId: 0 });
          accounts.forEach(element => {
            this.Accounts.push({ AccountNumber: element.AccountNumber.trim().toUpperCase(), AccountId: element.AccountId });
          });
        }
      }
    );
  }

  updateDashboardComponents(): void {
    this.sessionService.trendsForm = this.form;
    
    this.surchargeLoading = true;
    this.apiService.makeStandardApiCall('values/GetSurchargeTotalByMonth', this.form).subscribe(
      (data: any) => {
        const chartData = appConstants.fun.parseChartDataFromApi(JSON.parse(data.Value), 'TotalSurcharge');
        this.dataTable = new MatTableDataSource<SurchargeTotal>(JSON.parse(data.Value));

        // Set values to chart
        this.surchargeTotalChartLabels = chartData.labels;
        this.surchargeTotalChartData[0].data = chartData.values;
        this.surchargeTotalChartOptions.isLoading = false;
        this.surchargeTotalChartOptions.tooltips.callbacks;
        this.surchargeTotalChartColors = [
          {
            backgroundColor: 'rgba(255,255,255,0)',
            borderColor: 'rgba(102,163,255,1)', // Data drive this
            pointBackgroundColor: 'rgba(102,163,255,1)',
            pointBorderColor: 'rgba(102,163,255,0)',
          }
        ];
        this.surchargeLoading = false;
      }
    );
    
  }

  downloadSearch(): void {
    this.apiService.downloadFile('GetSurchargeMonthDownload', this.form).subscribe((response: any) => { //when you use stricter type checking
      let blob: any = new Blob([response], { type: 'application/octet-stream' });
      const url = window.URL.createObjectURL(blob);
      fileSaver.saveAs(blob, 'TotalSurchargeByMonth.xlsx');
    }), (error: any) => 
      () => this.notification.open('File downloaded successfully');
  }

}
